export var SessionStorage;
(function (SessionStorage) {
    SessionStorage["TOKEN"] = "token";
    SessionStorage["PROFILE_TYPE"] = "profileType";
    SessionStorage["PROFILE_ID"] = "profileId";
    SessionStorage["PARTNER_ID"] = "partnerId ";
    SessionStorage["PLACE_ID"] = "placeId";
    SessionStorage["USER_ID"] = "userId";
})(SessionStorage || (SessionStorage = {}));
//# sourceMappingURL=sessionStorage.enum.js.map